import src from "IMAGE";
export default { src, width: 204, height: 56, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ABAeM7UIHS66DA8wRhMTM0YNETY/DhI3NB0RMjMeEC0uAAgcKb0IHCm5Bw0XSg4QH0oKEx9bCBQfVQ4UIEYKEx5eeWsK4o7BQNUAAAAASUVORK5CYII="};
